import {FieldResult} from "./FieldResult";

export class FieldResponse {

  public results: Array<FieldResult>;

  public description: string;

  public value: string;

  public code: string;

  public type: string;

  public clazz: string;

  public typeParent: string;
}



// WEBPACK FOOTER //
// ./src/models/FieldResponse.ts